import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function NarcoticDestructionMethodologyPage() {
  return (
    <CustomerMethodologyPage
      title="Narcotic destruction compliance — overview"
      description="How WeConsult Rx supports DEA-compliant narcotic destruction documentation and verification."
      path="/trust/narcotic-destruction-compliance"
    >
      <p>
        The narcotic destruction module helps facilities document controlled
        substance destruction events with witness signatures, inventory
        reconciliation, and a public verification link for auditors.
      </p>
      <h2>What it covers</h2>
      <ul>
        <li>Destruction event logging with dual-witness attestation.</li>
        <li>Inventory reconciliation before and after destruction.</li>
        <li>Verifiable record suitable for DEA and state board review.</li>
      </ul>
      <h2>How it helps</h2>
      <p>
        Consultant pharmacists get a structured workflow that replaces paper
        logs and ensures every destruction event is documented consistently
        across facilities.
      </p>
    </CustomerMethodologyPage>
  );
}
